<template lang="pug">

    .field.left.icon(:class='{ required: isRequired }')
        label(v-if='label') {{ label }}
        .ui.left.icon.error.input
            input(type='text' v-bind:value='viewValue' v-bind:disabled='disabled' readonly)
            i.calendar.icon
        slot

</template>

<script>
    import * as fecha from 'fecha'
    import * as R from 'ramda'
    import Pikaday from 'pikaday'
    import { to_ddmmyyyy as date_to_ddmmyyyy } from '@/utils/date'

    //noinspection ReservedWordAsName
    export default {
        computed: {
            viewValue() {
                return R.ifElse(
                    R.isNil,
                    R.always(''),
                    date => date_to_ddmmyyyy(new Date(date))
                )(this.value)
            }
        },

        mounted() {
            // Pikaday initialisieren und konfigurieren
            //noinspection JSUnusedGlobalSymbols
            this.picker = new Pikaday({
                field: this.$el.querySelector('input'),
                firstDay: 1,
                format: 'DD.MM.YYYY',
                onSelect: date => {
                    //console.log(date.valueOf())
                    R.cond([
                        [ R.equals('String'), () => this.$emit('input', fecha.format(date, 'YYYY-MM-DD'))],
                        [ R.equals('Number'), () => this.$emit('input', date.valueOf())]
                    ])(this.formatTo)

                    // this.$emit('input', fecha.format(date, 'YYYY-MM-DD'))
                    //this.$emit('input', date.valueOf())
                }
            })
        },

        props: {

            value: {
                required: true
            },

            label: {
                type: String,
            },

            isRequired: {
                type: Boolean,
                default: false
            },

            disabled: {
                type: Boolean,
                default: false
            },

            formatTo: {
                type: String,
                default: 'String'
            }

        }

    }

</script>
